import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FateDropdown } from 'fate-editor';

/**Componente per la dropdown delle citazioni Tosefta */
@Component({
  selector: 'app-tosefta-dropdown',
  templateUrl: '../quote-template.html',
  styleUrls: ['../editor-dropdowns.css']
})
export class ToseftaDropdownComponent implements FateDropdown {
  /**Input, la stringa eventualmente selezionata */
  @Input()
  public value: string;
  /**Emettitore per il valore selezionato dalla dropdown */
  @Output() public valueChange = new EventEmitter<string>();

  /**Elenco delle citazioni Tosefta */
  noteList = [
    {
      etichetta: '‘Arakhìn',
      valore: 'Toseftà, <i>‘Arakhìn</i>'
    },
    {
      etichetta: '‘Avodà Zarà',
      valore: 'Toseftà, <i>‘Avodà Zarà</i>'
    },
    {
      etichetta: '‘Eduyòt',
      valore: 'Toseftà, <i>‘Eduyòt</i>'
    },
    {
      etichetta: '‘Eruvìn',
      valore: 'Toseftà, <i>‘Eruvìn</i>'
    },
    {
      etichetta: '‘Oqatzìm',
      valore: 'Toseftà, <i>‘Oqatzìm</i>'
    },
    {
      etichetta: '‘Orlà',
      valore: 'Toseftà, <i>‘Orlà</i>'
    },
    {
      etichetta: 'Bavà Batrà',
      valore: 'Toseftà, <i>Bavà Batrà</i>'
    },
    {
      etichetta: 'Bavà Metzi‘à',
      valore: 'Toseftà, <i>Bavà Metzi‘à</i>'
    },
    {
      etichetta: 'Bavà Qammà',
      valore: 'Toseftà, <i>Bavà Qammà</i>'
    },
    {
      etichetta: 'Bekhoròt',
      valore: 'Toseftà, <i>Bekhoròt</i>'
    },
    {
      etichetta: 'Berakhòt',
      valore: 'Toseftà, <i>Berakhòt</i>'
    },
    {
      etichetta: 'Betzà',
      valore: 'Toseftà, <i>Betzà</i>'
    },
    {
      etichetta: 'Bikkurìm',
      valore: 'Toseftà, <i>Bikkurìm</i>'
    },
    {
      etichetta: 'Chaghigà',
      valore: 'Toseftà, <i>Chaghigà</i>'
    },
    {
      etichetta: 'Challà',
      valore: 'Toseftà, <i>Challà</i>'
    },
    {
      etichetta: 'Chullìn',
      valore: 'Toseftà, <i>Chullìn</i>'
    },
    {
      etichetta: 'Demài',
      valore: 'Toseftà, <i>Demài</i>'
    },
    {
      etichetta: 'Ghittìn',
      valore: 'Toseftà, <i>Ghittìn</i>'
    },
    {
      etichetta: 'Horayòt',
      valore: 'Toseftà, <i>Horayòt</i>'
    },
    {
      etichetta: 'Kelìm',
      valore: 'Toseftà, <i>Kelìm</i>'
    },
    {
      etichetta: 'Keritòt',
      valore: 'Toseftà, <i>Keritòt</i>'
    },
    {
      etichetta: 'Ketubbòt',
      valore: 'Toseftà, <i>Ketubbòt</i>'
    },
    {
      etichetta: 'Kilàim',
      valore: 'Toseftà, <i>Kilàim</i>'
    },
    {
      etichetta: 'Ma‘asèr Shenì',
      valore: 'Toseftà, <i>Ma‘asèr Shenì</i>'
    },
    {
      etichetta: 'Ma‘asròt',
      valore: 'Toseftà, <i>Ma‘asròt</i>'
    },
    {
      etichetta: 'Makhshirìn',
      valore: 'Toseftà, <i>Makhshirìn</i>'
    },
    {
      etichetta: 'Makkòt',
      valore: 'Toseftà, <i>Makkòt</i>'
    },
    {
      etichetta: 'Me‘ilà',
      valore: 'Toseftà, <i>Me‘ilà</i>'
    },
    {
      etichetta: 'Meghillà',
      valore: 'Toseftà, <i>Meghillà</i>'
    },
    {
      etichetta: 'Menachòt',
      valore: 'Toseftà, <i>Menachòt</i>'
    },
    {
      etichetta: 'Miqwaòt',
      valore: 'Toseftà, <i>Miqwaòt</i>'
    },
    {
      etichetta: 'Mo‘èd Qatàn',
      valore: 'Toseftà, <i>Mo‘èd Qatàn</i>'
    },
    {
      etichetta: 'Nazìr',
      valore: 'Toseftà, <i>Nazìr</i>'
    },
    {
      etichetta: 'Nedarìm',
      valore: 'Toseftà, <i>Nedarìm</i>'
    },
    {
      etichetta: 'Nega‘ìm',
      valore: 'Toseftà, <i>Nega‘ìm</i>'
    },
    {
      etichetta: 'Niddà',
      valore: 'Toseftà, <i>Niddà</i>'
    },
    {
      etichetta: 'Ohalòt',
      valore: 'Toseftà, <i>Ohalòt</i>'
    },
    {
      etichetta: 'Parà',
      valore: 'Toseftà, <i>Parà</i>'
    },
    {
      etichetta: 'Peà',
      valore: 'Toseftà, <i>Peà</i>'
    },
    {
      etichetta: 'Pesachìm',
      valore: 'Toseftà, <i>Pesachìm</i>'
    },
    {
      etichetta: 'Qiddushìn',
      valore: 'Toseftà, <i>Qiddushìn</i>'
    },
    {
      etichetta: 'Rosh haShanà',
      valore: 'Toseftà, <i>Rosh haShanà</i>'
    },
    {
      etichetta: 'Sanhedrìn',
      valore: 'Toseftà, <i>Sanhedrìn</i>'
    },
    {
      etichetta: 'Shabbàt',
      valore: 'Toseftà, <i>Shabbàt</i>'
    },
    {
      etichetta: 'Sheqalìm',
      valore: 'Toseftà, <i>Sheqalìm</i>'
    },
    {
      etichetta: 'Shevi‘ìt',
      valore: 'Toseftà, <i>Shevi‘ìt</i>'
    },
    {
      etichetta: 'Shevu‘òt',
      valore: 'Toseftà, <i>Shevu‘òt</i>'
    },
    {
      etichetta: 'Sotà',
      valore: 'Toseftà, <i>Sotà</i>'
    },
    {
      etichetta: 'Sukkà',
      valore: 'Toseftà, <i>Sukkà</i>'
    },
    {
      etichetta: 'Ta‘anìt',
      valore: 'Toseftà, <i>Ta‘anìt</i>'
    },
    {
      etichetta: 'Tahoròt',
      valore: 'Toseftà, <i>Tahoròt</i>'
    },
    {
      etichetta: 'Temurà',
      valore: 'Toseftà, <i>Temurà</i>'
    },
    {
      etichetta: 'Terumòt',
      valore: 'Toseftà, <i>Terumòt</i>'
    },
    {
      etichetta: 'Tevùl Yom',
      valore: 'Toseftà, <i>Tevùl Yom</i>'
    },
    {
      etichetta: 'Yadàim',
      valore: 'Toseftà, <i>Yadàim</i>'
    },
    {
      etichetta: 'Yevamòt',
      valore: 'Toseftà, <i>Yevamòt</i>'
    },
    {
      etichetta: 'Yomà',
      valore: 'Toseftà, <i>Yomà</i>'
    },
    {
      etichetta: 'Zavìm',
      valore: 'Toseftà, <i>Zavìm</i>'
    },
    {
      etichetta: 'Zevachìm',
      valore: 'Toseftà, <i>Zevachìm</i>'
    }
  ]; 

  /**Indice elemento selezionato */
  public selected = 0;

  /**
   * Metodo che gestisce l'emissione del valore selezionato
   * @param value {any} il valore selezionato
   */
  public changeValue(value) {
    this.valueChange.emit(value);
  }

  /**Metodo che gestisce la selezione del successivo */
  public selectNext() {
    this.selected++;
    if (this.selected >= this.noteList.length) {
      this.selected = this.noteList.length - 1;
    }
  };
  /**Metodo che gestisce la selezione del precedente */
  public selecPrevious() {
    this.selected--;
    if (this.selected < 0) {
      this.selected = 0;
    }
  };
  /**Metodo che conferma la selezione lanciando il metodo di cambio valore */
  public confirmSelection() {
    this.changeValue(this.noteList[this.selected]);
  };
  constructor() { }

}
